var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2587 9.46994L16.0787 14.2899C16.4687 14.6799 16.4687 15.3199 16.0787 15.7099C15.8787 15.8999 15.6287 15.9999 15.3687 15.9999C15.1087 15.9999 14.8587 15.8999 14.6587 15.7099L9.83865 10.8899C8.85865 11.5899 7.66865 11.9999 6.36865 11.9999C3.05865 11.9999 0.368652 9.30994 0.368652 5.99994C0.368652 2.68994 3.05865 -6.10352e-05 6.36865 -6.10352e-05C9.67865 -6.10352e-05 12.3687 2.68994 12.3687 5.99994C12.3687 7.29994 11.9587 8.48994 11.2587 9.46994ZM2.36865 5.99994C2.36865 8.20994 4.15865 9.99994 6.36865 9.99994C8.57865 9.99994 10.3687 8.20994 10.3687 5.99994C10.3687 3.78994 8.57865 1.99994 6.36865 1.99994C4.15865 1.99994 2.36865 3.78994 2.36865 5.99994ZM7.36865 4.99994H8.36865C8.91865 4.99994 9.36865 5.44994 9.36865 5.99994C9.36865 6.54994 8.91865 6.99994 8.36865 6.99994H7.36865V7.99994C7.36865 8.54994 6.91865 8.99994 6.36865 8.99994C5.81865 8.99994 5.36865 8.54994 5.36865 7.99994V6.99994H4.36865C3.81865 6.99994 3.36865 6.54994 3.36865 5.99994C3.36865 5.44994 3.81865 4.99994 4.36865 4.99994H5.36865V3.99994C5.36865 3.44994 5.81865 2.99994 6.36865 2.99994C6.91865 2.99994 7.36865 3.44994 7.36865 3.99994V4.99994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.643bc04dc8a9f899dfcd6e921d6e07a4.svg";
export { ForwardRef as ReactComponent };